import { apiFetch } from "./client";

// Backend returns { course_ids: [...] }.
export const listFavorites = () => apiFetch("/api/favorites");

export const addCourseFavorite = (courseId) =>
  apiFetch("/api/favorites", { method: "POST", body: { course_id: courseId } });

export const removeCourseFavorite = (courseId) =>
  apiFetch(`/api/favorites/${courseId}`, { method: "DELETE" });
